module.exports = __webpack_public_path__ + "static/media/logo-tokio.0d926891.svg";